export const youthAccountProductCodes = ['741', '742'];
export const YOUTH_ACCOUNT_PAYMENT_LIMIT = 200;
